import { useState } from "react";
import { useTranslation } from "react-i18next";
// import chevronUp from '../../../public/icons/chevron_up_alt_blue.svg';
// import chevronDown from '../../../public/icons/chevron_down_alt_blue.svg';

interface SelectorProp {
    options: {value: string, option: string}[]
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
    value?: string
    error?: boolean
}

export default function Selector(props: SelectorProp) {
    const [openSelector, setOpenSelector] = useState<boolean>(false);
    const { t } = useTranslation(['common']);
    return (
        <select
            className={`select-primary${props.error ? '__required' : '__default'}`}
            id="currency"
            onClick={() => setOpenSelector(!openSelector)}
            onBlur={() => setOpenSelector(false)}
            onChange={props.onChange}
            value={props.value}
            // style={{backgroundImage: openSelector ? `url('${chevronUp}') ` : `url('${chevronDown}')`, maxWidth: "300px"}}
        >
            <option hidden disabled className="Extra2" value={''}>{t('common:buttons.select.placeholder')}</option>
            {props.options.map((option, i) =>
                <option
                    key={i}
                    value={option.value}
                    // selected={option.value === props.value}
                >
                    {option.option}
                </option>
            )}
        </select>
    );
}
